import React, { useState, useEffect } from "react";
import reportAPI from "../../../../api/report";
import { FilterYearMonthType } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import {
  STYLEBODY,
  TABLE,
  LEFTTABLE,
  THTABLE,
  RIGHTTABLE,
  TRTABLE,
  TXLEFT,
  TXCENTER,
} from "../../../../utils/useStyle";
import { displayValue } from "../../../../components/functions/Functions";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ReportTimeAttempt = ({ userDept }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    ad_mean: 0,
    ad_median: 0,
    ad_min: 0,
    ad_max: 0,
    ad_sd: 0,
    ad_per25: 0,
    ad_per75: 0,
    ad_number: 0,
    //
    kid1_mean: 0,
    kid1_median: 0,
    kid1_min: 0,
    kid1_max: 0,
    kid1_sd: 0,
    kid1_per25: 0,
    kid1_per75: 0,
    kid1_number: 0,
    //
    kid2_mean: 0,
    kid2_median: 0,
    kid2_min: 0,
    kid2_max: 0,
    kid2_sd: 0,
    kid2_per25: 0,
    kid2_per75: 0,
    kid2_number: 0,
    //
    all_mean: 0,
    all_median: 0,
    all_min: 0,
    all_max: 0,
    all_sd: 0,
    all_per25: 0,
    all_per75: 0,
    all_number: 0,
    checkTask: [],
  });

  const [year, setYear] = useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [month, setMonth] = useState({
    label: "ทุกเดือน",
    value: "ALL",
  });
  const [type, setType] = useState({
    label: "-",
    value: "NONE",
  });

  useEffect(() => {
    // Use backend API instead of frontend processing
    const fetchData = async () => {
      try {
        const response = await reportAPI.getTimeAttemptReport({
          year: String(year?.value),
          month: String(month?.value),
          type: String(type?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching time attempt report:", error);
      }
    };
    fetchData();
  }, [month, year, type, userDept]);

  const tabel = [
    {
      name: "Mean",
      adult: data?.ad_mean,
      kid1: data?.kid1_mean,
      kid2: data?.kid2_mean,
      all: data?.all_mean,
    },
    {
      name: "Median",
      adult: data?.ad_median,
      kid1: data?.kid1_median,
      kid2: data?.kid2_median,
      all: data?.all_median,
    },
    {
      name: "Min",
      adult: data?.ad_min,
      kid1: data?.kid1_min,
      kid2: data?.kid2_min,
      all: data?.all_min,
    },
    {
      name: "Max",
      adult: data?.ad_max,
      kid1: data?.kid1_max,
      kid2: data?.kid2_max,
      all: data?.all_max,
    },
    {
      name: "SD",
      adult: data?.ad_sd,
      kid1: data?.kid1_sd,
      kid2: data?.kid2_sd,
      all: data?.all_sd,
    },
    {
      name: "Percentile 25th",
      adult: data?.ad_per25,
      kid1: data?.kid1_per25,
      kid2: data?.kid2_per25,
      all: data?.all_per25,
    },
    {
      name: "Percentile 75th",
      adult: data?.ad_per75,
      kid1: data?.kid1_per75,
      kid2: data?.kid2_per75,
      all: data?.all_per75,
    },
    {
      name: "n",
      adult: data?.ad_number,
      kid1: data?.kid1_number,
      kid2: data?.kid2_number,
      all: data?.all_number,
    },
  ];

  const onClickExportPerformingToPDF = async () => {
    try {
      setLoading(true);
      const doc = new jsPDF("p", "px", "a4");

      const docElement = document.getElementById(
        "รายงานระยะเวลาในการทำหัตถการ"
      );
      const canvas = await html2canvas(docElement, { scale: 3 });
      const image = canvas.toDataURL("image/png");

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      const widthRatio = pageWidth / canvas.width;
      const heightRatio = pageHeight / canvas.height;
      const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;

      const canvasWidth = canvas.width * ratio - 50;
      const canvasHeight = canvas.height * ratio - 50;

      const marginX = (pageWidth - canvasWidth) / 2;
      const marginY = 20;
      doc.addImage(image, "PNG", marginX, marginY, canvasWidth, canvasHeight);
      await doc.save(`รายงานระยะเวลาในการทำหัตถการ.pdf`);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={``}>
      <div className="my-10">
        <div className="flex flex-col gap-4">
          <div className="text-black text-lg font-medium">
            รายงานระยะเวลาในการทำหัตถการ
            <div className={STYLEBODY}>
              ของปี {year?.label}
              แยกตามประเภทของสาย {type?.label}
            </div>
          </div>
          <div className=" flex items-end gap-2 my-3 ">
            <FilterYearMonthType
              year={year}
              setYear={setYear}
              month={month}
              setMonth={setMonth}
              type={type}
              setType={setType}
            />

            <ButtonExcel
              onClick={() => {
                onClickExportPerformingToPDF();
              }}
              loading={loading}
            />
          </div>
        </div>
        <table id="รายงานระยะเวลาในการทำหัตถการ" className={`${TABLE}`}>
          <thead>
            <tr>
              <th className={LEFTTABLE}>Procedure Time(min)</th>
              <th className={THTABLE}> Children (&lt;10 y) </th>
              <th className={THTABLE}> Children (&lt;18 y) </th>
              <th className={THTABLE}> Adults </th>
              <th className={RIGHTTABLE}> Total </th>
            </tr>
          </thead>
          <tbody>
            {tabel?.map((item, index) => (
              <tr key={index} className={TRTABLE}>
                <td className={TXLEFT}> {item?.name}</td>
                <td className={TXCENTER}>{displayValue(item?.kid1)}</td>
                <td className={TXCENTER}>{displayValue(item?.kid2)}</td>
                <td className={TXCENTER}>{displayValue(item?.adult)}</td>
                <td className={TXCENTER}>{displayValue(item?.all)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        *หมายเหตุ n คือจำนวนผู้ป่วยที่ได้รับการใส่สายที่ได้รับการกรอกข้อมูล
        วันเกิด
        ,วันที่ใส่สายสำเร็จ,ข้อมูลเวลาในการเริ่มใส่สายและเวลาในการสำเร็จการใส่สาย
      </div>
    </div>
  );
};

export default ReportTimeAttempt;
